import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ResolveFn } from '@angular/router';
import { filter, map, take } from 'rxjs';

import { AuthSelectorsFacade } from '@ps/auth-data-access';

import { UserSettingsActionsFacade } from '../state/user-settings.actions.facade';
import { UserSettingsSelectorsFacade } from '../state/user-settings.selectors.facade';

/**
 * Loads the user's dashboard preferences before the dashboard route activates.
 *
 * Resolves once the load settles — any already-cached preferences (fresh or
 * expired) resolve immediately and refresh in the background, while a
 * first-ever load resolves after the fetch completes — so the survey table
 * renders with the correct columns and no flash.
 */
export const dashboardPreferencesResolver: ResolveFn<boolean> = () => {
  const actions = inject(UserSettingsActionsFacade);
  const selectors = inject(UserSettingsSelectorsFacade);
  const auth = inject(AuthSelectorsFacade);

  actions.loadPreferences({ isServiceBuyer: auth.hasImpersonatedBuyer() });

  return toObservable(selectors.preferencesLoading).pipe(
    filter((loading) => !loading),
    take(1),
    map(() => true),
  );
};
